var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title is-4"},[_vm._v("Rapportages")]),_c('button',{staticClass:"button is-fullwidth is-primary",on:{"click":function($event){return _vm.$router.push({ name: 'rapportage-toevoegen' })}}},[_vm._v(" Creëer nieuwe rapportage ")]),_c('br'),_c('rapportageTable',{attrs:{"rapportages":_vm.rapportages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }